import { MessageType } from "lib/features/message/types";
import api from "./api";

const chatServices = {
  createChat(payload: object) {
    return api.post("/chat/create", payload);
  },

  getChatByChannelUrl(channel: string, userId: number) {
    const endpoint = `/chat/find-by-channel?channel=${channel}&userId=${userId}`;
    return api.get(endpoint);
  },
  getConversations(userId: number) {
    const endpoint = `/twilio/${userId}`;
    return api.get(endpoint);
  },
  getUserTokenForChat(userId: string) {
    const endpoint = `/twilio/token/${userId}`;
    return api.get(endpoint);
  },

  getMyChats(userId: number, selectedChat: MessageType) {
    const endpoint = `/chat/all-my-chats?userId=${userId}&chatType=${selectedChat}`;
    return api.get(endpoint);
  },

  getChannelUrl(userId1: number, userId2: number) {
    const queryParams = {
      userId1: userId1,
      userId2: userId2,
    };
    const endpoint = `/chat/find-by-ids?userId1=${userId1}&userId2=${userId2}`;
    return api.get(endpoint);
  },

  getChannelUrlByPhone(userId: number, customerPhone: string) {
    const endpoint = `/chat/find-by-phone?userId=${userId}&customerPhone=${customerPhone}`;
    return api.get(endpoint);
  },

  sendChatNotification(channel: string, userId: number, payload: object) {
    return api.post(
      `/chat/chats-notification?channel=${channel}&userId=${userId}`,
      payload
    );
  },
  createChannel(payload: object) {
    return api.post(
      `/twilio`,
      payload
    );
  }
};

export default chatServices;
